<template>
  <v-container>
    <v-card color="">
      <v-card-title style="color: #B08836"  class="font-weight-bold">
        <h2 class="heading font-weight-bold">Firma Electrónica</h2>
        <v-spacer></v-spacer>
        <v-btn color="#0A4A79" dark to="/panel" small>
          <v-icon small class="mr-5">mdi-arrow-left</v-icon>
          Ir a Panel
        </v-btn>
      </v-card-title>
      <v-divider inset></v-divider>
      <v-card-text>
        <v-form @submit.prevent="validate" ref="form" v-model="valid" lazy-validation>
          <!-- <v-row>
            <v-col align="center">
               <h3>BAJO PROTESTA DE DECIR VERDAD, ADJUNTO LOS SIGUIENTES DOCUMENTOS</h3>
            </v-col>
          </v-row><br> -->
          <v-card>
            <v-row class="mt-n1 ml-5">
              <v-col cols="12">
                <p class="font-weight-black" align="">Firmar Documento</p>
              </v-col>
            </v-row>

            <v-row class="mt-n5">
              <v-col cols="12"  align="center">
                <span class="font-weight-bold">Subir el Escrito</span>
              </v-col>
            </v-row>

            <v-row justify="center" class="mt-n5 mr-9">
              <v-col cols="12" align="center">
                <v-file-input
                  v-model="file_promocion"
                  color="blue darken-2"
                  label="Seleccionar la promoción"
                  prepend-icon="mdi-paperclip"
                  outlined
                  multiple
                  dense
                  show-size
                  accept="application/pdf, .doc, .docx"
                  truncate-length="50"
                  :rules="fileRules"
                  @change="SelccionarArchivo($event)"
                ></v-file-input>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" md="6">
                <v-row class="mt-n6">
                  <v-col cols="12">
                    <p class="font-weight-black" align="center">Firma Firel</p>
                  </v-col>
                </v-row>

                <v-row class="mt-n6 ml-7">
                  <v-col cols="11">
                    <v-file-input
                      v-model="file_firel"
                      color="blue darken-2"
                      label="Seleccionar la firel"
                      prepend-icon="mdi-certificate"
                      outlined
                      multiple
                      dense
                      show-size
                      accept=".pfx"
                      @change="SeleccionarPfx($event)"
                      truncate-length="50"
                    ></v-file-input>
                  </v-col>
                </v-row>

                <v-row class="mt-n6 ml-7">
                  <v-col cols="11">
                    <v-text-field outlined dense
                      v-model="password"
                      label="Contraseña"
                      type="text"
                      prepend-icon="mdi-lock-outline"
                      :type="showpass ? 'text' : 'password'"
                      :append-icon="showpass ? 'mdi-eye' : 'mdi-eye-off'"
                      @click:append="showpass = !showpass"
                      truncate-length="50"
                    >
                    </v-text-field>
                  </v-col>
                  <v-col cols="1">
                    <v-btn
                      :loading="loadingFirma"
                      v-model="activarBoton"
                      @click="validate()"
                      :disabled="!activarBoton"
                      color="primary">FIRMAR
                    </v-btn>
                  </v-col>
                </v-row><br>
                <!-- <v-row class="mt-n6 ml-15">
                  <v-col cols="2">
                    <v-btn
                      :loading="loadingFirma"
                      v-model="activarBoton"
                      @click="firmar()"
                      :disabled="!activarBoton"
                      color="primary">FIRMAR FIREL
                    </v-btn>
                  </v-col>
                </v-row> -->
              </v-col>
            </v-row><br>
          </v-card>
        </v-form>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import {SelectFileSign,message,SelectPfx,OpenPfx,PKCS7creado,extFileUpload} from '@/services/cliente';
import { CertificateRequest } from '@/services/clasesFirma';
  const Swal = require('sweetalert2');
  import { mapGetters } from "vuex";
  export default {
    data(){
      return {
        pkcs7:'',
        activarBoton: false,
        message:'',
        extArchivoCargado:'',
        filePFXselct:'',
        file_firel: [],
        password:'',
        showpass: false,
        loading: false,
        loadingFirma: false,
        valid: true,
        file_promocion:[],
        creaevidencia:true,
        user:'',
        key:[],
        cert:[],
        password:'',
        fileRules: [
          files => !files || !files.some(file => file.size > 2097152) || 'El documento no debe exceder de 20MB'
          // v => !v || 'El Campo es Requerido',
        ],
      }
    },
    computed: {
      ...mapGetters([
        "currentUser",
        "roleUser"
      ]),
    },
    watch: {

    },
    mounted() {

    },
    methods:{
      SelccionarArchivo(file) {
        SelectFileSign(file[0]).then((isValidFile)=>{
            if(isValidFile){
                this.message=message;
                this.extArchivoCargado=extFileUpload;
            }
         });
      },
      SeleccionarPfx(filePFX) {
        this.activarBoton=SelectPfx(filePFX[0]);
        if(this.activarBoton){
            this.filePFXselct=filePFX[0];
        }
      },
      firmar() {
        OpenPfx(this.filePFXselct,this.password).then((isCreatePKCS7)=>{
            if(isCreatePKCS7){
                var fecha = new Date();
                this.pkcs7=PKCS7creado;
                this.FileName = "pkcs7_" + fecha.valueOf() + "." + this.extArchivoCargado;
                this.creaEvidencia(this.pkcs7);
            } else {
              Swal.fire({
                icon: 'warning',
                title: 'Archivo PFX o contraseña invalida, Favor de Verificar',
                confirmButtonText: "Aceptar",
                // timer: 1500,
              })
            }
         });
      },

      creaEvidencia(pkcs7)
      {
          Swal.fire({
            title: 'Estableciendo comunicación',
            html: 'Generando Evidencia Criptográfica ...',
            allowOutsideClick: false,
            showConfirmButton: false,
            onBeforeOpen: () => {
              Swal.showLoading()
            },
          })
        this.creaevidencia=true;
        this.loadingFirma = true;
        if(pkcs7){
           CertificateRequest.CertificateType = 3;
           CertificateRequest.Pkcs7Original = this.pkcs7;
           CertificateRequest.FileName = this.FileName;
           CertificateRequest.UserName = "Eliminar";
           this.$store.dispatch("FIREL_FIRMA", { url: "promocion/firmar", data: CertificateRequest })
           .then(response => {
             Swal.close();
             // console.log(response.data);
             this.loadingFirma = false;
             this.saveTextAsFile(response.data.data.PdfBase64);
             this.file_firel = [];
             this.file_promocion = [];
             this.password = '';
             this.activarBoton = false;
             this.message='';
             this.extArchivoCargado='';
             this.filePFXselct='';
             this.pkcs7='';
             this.FileName ='';
           })
           .catch(err => {
             console.log(err);
             this.loadingFirma = false;
             Swal.close();
           });
        } else {
          this.creaevidencia=false;
        }
      },

      saveTextAsFile(fileB64) {
        var fecha = new Date();
        let blob = this.b64toBlob(fileB64, 'application/pdf', 512);
        let fileNameToSaveAs = "evidencia_" + fecha.valueOf() + ".pdf";
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        // link.setAttribute('target' ,'_blank');
        link.setAttribute('download', fileNameToSaveAs);
        document.body.appendChild(link);
        link.click();
      },

      b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;

        var byteCharacters = atob(b64Data);
        var byteArrays = [];

        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
          var slice = byteCharacters.slice(offset, offset + sliceSize);

          var byteNumbers = new Array(slice.length);
          for (var i = 0; i < slice.length; i++) {
            byteNumbers[i] = slice.charCodeAt(i);
          }

          var byteArray = new Uint8Array(byteNumbers);

          byteArrays.push(byteArray);
        }

        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
      },

      validate() {
        if (!this.$refs.form.validate()) {
          Swal.fire({
            icon: 'warning',
            title: 'Favor de verificar los campos Requeridos',
            confirmButtonText: "Aceptar",
          })
        } else if (!this.file_promocion.length ) {
          Swal.fire({
            icon: 'warning',
            title: 'Favor de seleccionar archivo',
            confirmButtonText: "Aceptar",
          })
        } else if (!this.password) {
          Swal.fire({
            icon: 'warning',
            title: 'Favor de Ingresar contraseña',
            confirmButtonText: "Aceptar",
          })
        } else {
          this.firmar();
        }
      }
    }
  }
</script>
